import type { EventForm } from "../../../standalone/event-form";
import { jSith } from "../../../util/jquery-replacement";

/** TODO: use EventForm everywhere. This is to minimize diffs for now */
type LooseForm = Pick<EventForm, "eventId" | "profileId">;

export class EventFormConflictRepoService {
    public static addConflictByModel(formModel: LooseForm, conflict: any) {
        // The repo gates save for the segment being edited. A bound segment's conflict is keyed by
        // an occurrence this form does not own, so it could never be cleared and would block save
        // with no way for the user to resolve it.
        if (conflict?.candidateIsBound) return;

        return EventFormConflictRepoService.addConflict(
            formModel.eventId,
            formModel.profileId,
            conflict.candidateId,
            conflict.itemTypeId,
            conflict.occUUID,
        );
    }

    public static addConflict(eventId: number, profileId: number, itemId: number, itemTypeId: number, occUUID: string) {
        addRepo(eventId, profileId)[conflictKey(itemId, itemTypeId, occUUID)] = true;
    }

    public static removeConflictByObjectModel(formModel: LooseForm, item: any) {
        return EventFormConflictRepoService.removeConflictByObject(
            formModel.eventId,
            formModel.profileId,
            item.itemId,
            item.itemTypeId,
        );
    }

    public static removeConflictByObject(eventId: number, profileId: number, itemId: number, itemTypeId: number) {
        const conflictObj = addRepo(eventId, profileId) as Record<string, any>;
        jSith.forEach(conflictObj, function (key, val) {
            if (key.startsWith(itemId + "&" + itemTypeId + "&")) {
                delete conflictObj[key];
            }
        });
    }

    public static removeConflictByOccModel(formModel: LooseForm, occ: any) {
        return EventFormConflictRepoService.removeConflictByOcc(formModel.eventId, formModel.profileId, occ.uuid);
    }

    public static removeConflictByOcc(eventId: number, profileId: number, occUUID: string) {
        const conflictObj = addRepo(eventId, profileId) as Record<string, any>;
        jSith.forEach(conflictObj, function (key, val) {
            if (key.endsWith("&" + occUUID)) {
                delete conflictObj[key];
            }
        });
    }

    public static removeConflictByObjOccModel(formModel: LooseForm, item: any, occ: any) {
        return EventFormConflictRepoService.removeConflictByObjOcc(
            formModel.eventId,
            formModel.profileId,
            item.itemId,
            item.itemTypeId,
            occ.uuid,
        );
    }

    public static removeConflictByObjOcc(
        eventId: number,
        profileId: number,
        itemId: number,
        itemTypeId: number,
        occUUID: string,
    ) {
        const conflictObj = addRepo(eventId, profileId);
        jSith.forEach(conflictObj, function (key, val) {
            if (key === conflictKey(itemId, itemTypeId, occUUID)) {
                delete conflictObj[key];
            }
        });
    }

    public static getRepo(eventId: number, profileId: number) {
        return addRepo(eventId, profileId);
    }

    public static hasConflictsModel(formModel: LooseForm) {
        return EventFormConflictRepoService.hasConflicts(formModel.eventId, formModel.profileId);
    }

    public static hasConflicts(eventId: number, profileId: number) {
        let hasConflictsBool = false;
        jSith.forEach(addRepo(eventId, profileId), function (key, val) {
            hasConflictsBool = true;
        });
        return hasConflictsBool;
    }
}

const repo: any = {};

function repoKey(eventId: number, profileId: number) {
    return eventId + "&" + profileId;
}

function addRepo(eventId: number, profileId: number) {
    if (!repo[repoKey(eventId, profileId)]) {
        repo[repoKey(eventId, profileId)] = {};
    }
    return repo[repoKey(eventId, profileId)];
}

function conflictKey(itemId: number, itemTypeId: number, occUUID: string) {
    return itemId + "&" + itemTypeId + "&" + occUUID;
}
